export default {"src":"/_next/static/media/feedbackSubmitted.2872f35d.gif","height":150,"width":150,"blurWidth":0,"blurHeight":0};